import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { teamData } from '@/models/team-member.model';
import { BinderAccess } from '@/models/binder-access.model';

interface teamReturn {
  team: teamData[];
  shared: BinderAccess[];
}

interface removeReturn {
  shared: BinderAccess;
}

@Injectable({
  providedIn: 'root'
})
export class ShareService {
    sharedData = signal<BinderAccess[]>([]);
    teamData = signal<teamData[]>([]);

    shareLoading = signal<boolean>(false);
    removeLoading = signal<boolean>(false);

    baseUrl = environment.landmark_API_URL + '/binders/shared';

    http = inject(HttpClient);

  constructor(

  ) {

  }

  addAccess(accessRecord: any) {
    this.http.post<{shared: BinderAccess}>(`${this.baseUrl}`, accessRecord).subscribe((res) => {
      console.log('res', res);
      this.sharedData.set([...this.sharedData(), res.shared]);
      this.shareLoading.set(false);
    });
  }

  getSharedData(binderId: number, fid: number) {
    this.http.get<teamReturn>(`${this.baseUrl}?binderId=${binderId}&fid=${fid}`).subscribe((res) => {
        console.log('res', res);
        this.teamData.set(res.team);
        this.sharedData.set(res.shared);
        console.log('this.sharedData', this.sharedData());
    });
  }

  removeAccess(accessRecord: any) {
    this.removeLoading.set(true);
    this.http.delete<removeReturn>(`${this.baseUrl}`, { body: accessRecord, observe: 'body' }).subscribe((res) => {
      const removed = res.shared;
      console.log('res', res);
      this.sharedData.set(this.sharedData().filter((member) => member.UID !== removed.UID));
      this.removeLoading.set(false);
    });
  }

}
